import { appStore } from '../../../index';
import { observer } from 'mobx-react-lite';
import { Pages } from '../../../Stores/AppStore';
import { Button, ButtonType, Container, Dialog, ScanField, ScanIcon } from '../../UI';
import classes from './ScanPositions.module.css';
import * as React from 'react';
import { LNG } from '../../../Services/LanguageService';

export const ScanPositions = observer(() => {
  const _onCancelClick = () => {
    appStore.setPage(Pages.ScanJob);
  };

  const _onDoneClick = () => {
    appStore.setPage(Pages.Confirmation);
  };
  const _actions = (
      <>
        <Button label={LNG.Text('scannerApp.21')} onClick={_onCancelClick} />
        <Button disabled={!appStore.appState.positions.length} type={ButtonType.Primary} label={LNG.Text('scannerApp.22')} onClick={_onDoneClick} />
      </>
  );

  const _dialogActions = [
    {
      label: 'Ok',
      onClick: appStore.clearConfirmation
    }
  ];

  return (
      <Container>
        <ScanField onChange={appStore.checkPosition} />
        <div className={classes.actions}>
          {_actions}
        </div>
        <ScanIcon label={LNG.Text('scannerApp.23')} iconHeight={200} />
        <div className={classes.pos}>
          <div className={classes.actions}>
            <Button label={LNG.Text('scannerApp.24')} className={classes.edit} onClick={appStore.resetPositions} />
            <Button label={LNG.Text('scannerApp.25')} className={classes.edit} disabled={!appStore.appState.positions.length} onClick={appStore.deleteLastPosition} />
          </div>
          <div className={classes.wrapper}>
            <div className={classes.list}>
              {appStore.deployedMachine?.positions.map(p => {
                const cls = [classes.item];
                appStore.appState.positions.includes(p) && cls.push(classes.active);
                return <div key={String(p)} className={cls.join(' ')}>{p}</div>;
              })}
            </div>
          </div>
        </div>
        {appStore.confirmationMessage && <Dialog title={appStore.confirmationMessage} actions={_dialogActions} />}
      </Container>
  );
});
